export class Condition {
  id: number;
  name: string;
  description: string;
  conditionType: string;
  active: boolean;
  isManual: boolean;
  isSelected: boolean;
}
